<script setup lang="ts">
import { faMemo } from '@fortawesome/pro-duotone-svg-icons'

type Templates = CrystallizeProduct['components']['templates']

type TemplateMetadata = NonNullable<CrystallizeProduct['components']['templateMetadata']>

defineProps<{
  data: TemplateMetadata
  templates: Templates
}>()

const site = useSiteConfig()
</script>

<template>
  <ContentGrid class="items-center gap-y-s">
    <div class="col-span-4 md:col-span-2 lg:col-span-4 2xl:col-span-5 2xl:col-start-2 flex flex-col gap-m">
      <h3 v-text="data.title" />
      <CrystallizeRichText v-for="(block, key) in data.text" :key="key" :block="block" />
    </div>
    <ul v-if="templates?.length" class="col-span-4 md:col-span-2 lg:col-span-4 2xl:col-span-5 flex flex-col gap-2xs md:mx-l">
      <li v-for="({ template }, key) in templates" :key="key" class="bg-white p-m rounded-lg flex gap-m">
        <Icon :icon="faMemo" class="text-carbon-200 [--fa-primary-color:#2D2B84]" />
        <div>
          <h6 v-text="template?.title" />
          <span v-if="template?.updatedat" class="text-xs">
            Sist oppdatert <NuxtTime :locale="site.defaultLocale" :datetime="template.updatedat" day="2-digit" month="long" year="numeric" />
          </span>
        </div>
      </li>
    </ul>
  </ContentGrid>
</template>
